<app-item-emoji [emoji]="element().emoji" />
{{ element().text }}
@if (isDeleteMode) {
  <app-item-remove [itemComponent]="this" />
}
